module.exports = __webpack_public_path__ + "img/课程完成量.45a90d95.png";